import React from "react";

interface League {
  id: number;
  name: string;
  abbr: string;
  active_season_id: number | null;
  custom_domain: string | null;
  /** ActiveSupport::TimeZone name, e.g. "Eastern Time (US & Canada)". */
  time_zone: string;
  /**
   * One length in minutes per period — [20, 20, 20] for three periods, [25, 25]
   * for a league that plays halves. Its length is how many periods a game has
   * before overtime.
   */
  period_minutes: number[];
  created_at: string;
  updated_at: string;
}

interface LeagueContextType {
  currentLeague: League | null;
  setCurrentLeague: (league: League | null) => void;
  selectedSeasonId: number | null;
  setSelectedSeasonId: (seasonId: number | null) => void;
  leagues: League[];
  refreshLeagues: () => void;
  isLoading: boolean;
}

let LeagueContext = React.createContext<LeagueContextType>(null!);

export { LeagueContext, type League };
